module.exports = __webpack_public_path__ + "static/media/girl-17.40d09889.svg";